import { useState } from "react";
import { usePepI18n } from "../i18n/usePepI18n";
import { getAnalyticsConsent, setAnalyticsConsent } from "./pep-analytics";

export function AnalyticsConsentBanner() {
  const { t } = usePepI18n();
  const [visible, setVisible] = useState(() => getAnalyticsConsent() === "pending");

  if (!visible) return null;

  function choose(value: "granted" | "denied") {
    setAnalyticsConsent(value);
    setVisible(false);
  }

  return (
    <div
      className="pep-consent-banner position-fixed bottom-0 start-0 end-0 p-3 p-md-4"
      role="dialog"
      aria-live="polite"
      aria-label={t("analytics.consent.title")}
    >
      <div className="container">
        <div className="card border-0 shadow-lg">
          <div className="card-body p-4 d-flex flex-column flex-md-row align-items-md-center gap-3">
            <div className="flex-grow-1">
              <h2 className="h6 fw-bold mb-1">{t("analytics.consent.title")}</h2>
              <p className="small text-secondary mb-0">{t("analytics.consent.text")}</p>
            </div>
            <div className="d-flex gap-2 flex-shrink-0">
              <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => choose("denied")}>
                {t("analytics.consent.decline")}
              </button>
              <button type="button" className="btn btn-sm btn-primary" onClick={() => choose("granted")}>
                {t("analytics.consent.accept")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
